const minVisibleTime = 500

const baseCallBack = (time, data) => {
  const {
    data: { spm, ...rest }
  } = data
  return {
    spm: spm,
    params: rest
  }
}

export const exposeMap = {
  feedGood: {
    minVisibleTime,
    cb: (time, data) => {
      const {
        vnode: { context = {} }
      } = data
      const { good = {}, goodIndex } = context
      const { sku_id: skuId, ssu_list: ssuList = [] } = good
      const [ssu = {}] = ssuList
      const { ssu_id: ssuId, priceSpm = '' } = ssu
      return {
        spm: '7873.0',
        params: {
          sku_id: skuId,
          ssu_id: ssuId,
          sku_pos: goodIndex,
          price: priceSpm
        }
      }
    }
  },
  seckillGood: {
    minVisibleTime,
    cb: (time, data) => {
      const {
        // eslint-disable-next-line camelcase
        data: { good, sku_pos, discount_attribute }
      } = data
      return {
        spm: '5999.0',
        params: {
          sku_id: good ? Number(good.sku_id) : 0,
          ssu_id: good ? Number(good.ssu_id) : 0,
          sku_pos,
          price: good?.priceSpm || '',
          activity_id: good.activity_id ? good.activity_id + '' : '',
          discount_attribute
        }
      }
    }
  },
  fromGood: {
    minVisibleTime,
    cb: (time, data) => {
      const {
        // eslint-disable-next-line camelcase
        data: { sku_id, goodsStatus, price }
      } = data
      return {
        spm: '9580.0',
        params: {
          // eslint-disable-next-line camelcase
          sku_id: sku_id ? Number(sku_id) : 0,
          goods_status: goodsStatus || 0,
          price
        }
      }
    }
  },
  hotSaleList: {
    minVisibleTime,
    cb: (time, data) => {
      const {
        data: {
          /* eslint-disable */
          ssu_id,
          sku_id,
          sku_pos,
          str_sale_class1_id,
          datatype,
          goods_status,
          price
          /* eslint-enable */
        }
      } = data
      return {
        spm: '7711.0',
        params: {
          // eslint-disable-next-line camelcase
          ssu_id,
          sku_id,
          sku_pos,
          str_sale_class1_id,
          datatype,
          goods_status,
          price
        }
      }
    }
  },
  similyGood: {
    minVisibleTime,
    cb: (time, data) => {
      const {
        data: {
          /* eslint-disable */
          ssu_id,
          sku_id,
          sku_pos,
          from_sku_id,
          tag_name_similar,
          goods_status,
          price
          /* eslint-enable */
        }
      } = data
      return {
        spm: '9594.0',
        params: {
          // eslint-disable-next-line camelcase
          ssu_id,
          sku_id,
          sku_pos,
          from_sku_id,
          tag_name_similar,
          goods_status,
          price
        }
      }
    }
  },
  recommendGood: {
    minVisibleTime,
    cb: (time, data) => {
      const {
        // eslint-disable-next-line camelcase
        data: { ssu_id, sku_id, sku_pos, price }
      } = data
      return {
        spm: '9590.0',
        params: {
          // eslint-disable-next-line camelcase
          ssu_id,
          sku_id,
          sku_pos,
          price
        }
      }
    }
  },
  couponCenterList: {
    minVisibleTime,
    cb: (time, data) => {
      const {
        data: { modelId, isShopCoupon, couponStatus, index }
      } = data
      return {
        spm: '9622.0',
        params: {
          str_coupon_id: String(modelId),
          is_pop_coupon: String(isShopCoupon),
          coupon_state: String(couponStatus),
          coupon_pos: String(index) || ''
        }
      }
    }
  },
  purchaseGood: {
    minVisibleTime,
    cb: (time, data) => {
      const {
        data: { rank, skuId, ssuId }
      } = data
      return {
        spm: '9969.0',
        params: {
          sku_pos: Number(rank),
          sku_id: Number(skuId),
          ssu_id: Number(ssuId)
        }
      }
    }
  },
  cmsVideo: {
    minVisibleTime,
    cb: (time, data) => {
      const {
        data: { spm, spmJson }
      } = data
      return {
        spm: spm,
        params: spmJson
      }
    }
  },
  rechardAd: {
    minVisibleTime,
    cb: baseCallBack
  },
  couponExposure: {
    minVisibleTime,
    cb: baseCallBack
  },
  activityGoodExpose: {
    minVisibleTime,
    cb: baseCallBack
  },
  popGoodExpose: {
    minVisibleTime,
    cb: baseCallBack
  },
  changePriceGood: {
    minVisibleTime,
    cb: baseCallBack
  },
  goodRankExpose: {
    minVisibleTime,
    cb: baseCallBack
  },
  demandwordRankExpose: {
    minVisibleTime,
    cb: baseCallBack
  },
  activityAreaExpose: {
    minVisibleTime,
    cb: baseCallBack
  },
  homeGoodsExpose: {
    minVisibleTime,
    cb: baseCallBack
  },
  cmsStrageGoodExpose: {
    minVisibleTime,
    cb: baseCallBack
  }
}
